<script>
import aclService from '../../../../domain/acl/services/acl'

export default {
  data () {
    return {
      acls: [],
      selectedAcls: []
    }
  },
  mounted () {
    this.fetchAcls()
  },
  methods: {
    fetchAcls () {
      aclService.list()
        .then(response => {
          this.acls = response.data
        })
        .catch(error => {
          console.error('Erro ao buscar ACLs:', error)
        })
    },
    deleteSelectedAcls () {
      // Cria uma lista de IDs das ACLs selecionadas
      const selectedIds = this.selectedAcls.map(acl => acl.id)
      aclService.delete(selectedIds)
        .then(() => {
          // Remove as ACLs selecionadas da lista de ACLs
          this.acls = this.acls.filter(acl => !this.selectedAcls.includes(acl))
          // Limpa a lista de ACLs selecionadas
          this.selectedAcls = []
          console.log('ACLs excluídas com sucesso.')
        })
        .catch(error => {
          console.error('Erro ao excluir ACLs:', error)
        })
    },
    redirectToEditForm (id) {
      this.$router.push({ name: 'acl.editar', params: { id: id } })
    },
    selectAllAcls () {
      if (this.selectedAcls.length === this.acls.length) {
        // Se todas as ACLs já estiverem selecionadas, desmarque todas
        this.selectedAcls = []
      } else {
        // Caso contrário, selecione todas as ACLs
        this.selectedAcls = [...this.acls]
      }
    }
  }
}
</script>

<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">
            <div class="bg-light lter b-b wrapper-md">
              <div class="row">
                <div class="col-sm-6 col-xs-12">
                  <h1 class="font-thin h3">
                    ACL <span class="badge">{{ acls.length }}</span>
                  </h1>
                </div>
                <div class="col-sm-6 col-xs-12">
                  <div class="text-right text-left-xs">
                    <router-link :to="{ name: 'acl.novo' }" class="btn btn-sm btn-default">
                      <i class="fa fa-plus"></i> Nova ACL
                    </router-link>
                  </div>
                </div>
              </div>
            </div>

            <div class="panel panel-default">
              <div class="wrapper clearfix">
                <div class="col-sm-7 m-b-xs">
                  <button class="btn btn-sm btn-default" @click="deleteSelectedAcls" :disabled="selectedAcls.length < 1">Deletar</button>
                </div>
                <div class="col-sm-12">
                  <div class="table-responsive">
                    <table class="table table-hover table-striped b-t b-light">
                      <thead>
                      <tr>
                        <th style="width: 20px;">
                          <label class="i-checks m-b-none">
                            <input type="checkbox" @click="selectAllAcls">
                            <i></i>
                          </label>
                        </th>
                        <th>Nome</th>
                        <th>Código</th>
                        <th>Descrição</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="acl in acls" :key="acl.id" role="button" tabindex="0">
                        <td>
                          <label class="i-checks m-b-none">
                            <input type="checkbox" v-model="selectedAcls" :value="acl">
                            <i></i>
                          </label>
                        </td>
                        <td @click="redirectToEditForm(acl.id)">{{ acl.nome }}</td>
                        <td @click="redirectToEditForm(acl.id)">{{ acl.codigo }}</td>
                        <td @click="redirectToEditForm(acl.id)">{{ acl.descricao }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// Acls.vue?435736e1